import title from './title.js';

export default dsf.component({
  name: 'DsfTitle1',
  mixins: [title],
  ctrlCaption: "一级标题",
  props: {
    value: {
      type: [String, Number],
      default: '标题1'
    },
    fontType: {
      type: Number,
      default: 1
    }
  }
});